import React from 'react';

export function sentenceCase(s: string): string {
  const t = s.replace(/_/g, ' ').trim();
  return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
}

/** Small pill with an optional leading dot — meta row (#rank, review, transcript). */
export function MetaPill({
  label,
  bg,
  border,
  color,
  dot,
}: {
  label: string;
  bg: string;
  border: string;
  color: string;
  dot?: string;
}) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        borderRadius: 999,
        background: bg,
        border: `1px solid ${border}`,
        fontSize: 12,
        fontWeight: 500,
        color,
        whiteSpace: 'nowrap',
      }}
    >
      {dot && <span style={{ width: 7, height: 7, borderRadius: '50%', background: dot, flexShrink: 0 }} />}
      {label}
    </span>
  );
}
